/**
 * Extracts the city and state from a string in the format "<city>, <state> <zip>"
 *
 * @function
 * @param {string} [cityStateZip=''] - The string to extract the city and state from
 * @returns {string} The extracted city and state in the format "<city>, <state>"
 *
 * @example
 * const cityStateZip = "Seattle, WA 98105";
 * const cityState = getCityState(cityStateZip);
 * console.log(cityState); // Output: "Seattle, WA"
 */
const getCityState = (cityStateZip = '') => {
  if (!cityStateZip) return '';

  const [city, stateZip] = cityStateZip.split(', ');
  return city && stateZip ? `${city}, ${stateZip.split(' ')[0]}` : '';
};

/**
 * Extracts the zip from a string in the format "<city>, <state> <zip>"
 *
 * @function
 * @param {string} [cityStateZip=''] - The string to extract the zip from
 * @returns {string} The extracted zip
 *
 * @example
 * const cityStateZip = "Seattle, WA 98105";
 * const zip = getCityZip(cityStateZip);
 * console.log(zip); // Output: "98105"
 */
const getCityZip = (cityStateZip = '') => {
  if (!cityStateZip) return '';

  const [, stateZip] = cityStateZip?.split(', ');
  const [, zip] = stateZip?.split(' ');

  return zip ? zip : '';
};

export { getCityZip, getCityState };
